import React, { memo, useMemo } from "react";

import useTime from "../../../../../../hooks/useTime";
import useFormatDate from "../../../../../../hooks/useFormatDate";
import {
	getOwnBuildId,
	parseBuildId,
} from "../../../../../UpdateNotice/newBuild";
import LabeledContent from "../LabeledContent";

const DateTime = memo(() => {
	const now = useTime("every-second");

	const formatDate = useFormatDate();

	const date = useMemo(
		() => formatDate(now, "DD MMMM yyyy"),
		[formatDate, now],
	);

	const time = useMemo(() => formatDate(now, "kk:mm:ss"), [formatDate, now]);

	// Hover hint with the build of this page, in the time zone of the clock.
	const version = useMemo(() => {
		const build = parseBuildId(getOwnBuildId());
		if (!build) return undefined;
		const builtAt = formatDate(build.time, "DD.MM.yyyy kk:mm");
		return build.sha ? `ver. ${builtAt} · ${build.sha}` : `ver. ${builtAt}`;
	}, [formatDate]);

	return (
		<div title={version}>
			<LabeledContent label={date}>{time}</LabeledContent>
		</div>
	);
});

export default DateTime;
